<span>
  <h1 class="pt-3 mb-3">Change password</h1>
  <form [formGroup]="passwordForm" (ngSubmit)="submit()">
    <div class="row form-group">
      <label for="settings-old-pw" class="col-sm-4 col-md-4 col-form-label">Old password</label>
      <div class="col-md-6 col-lg-4">
        <input type="password"
               id="settings-old-pw"
               name="oldPassword"
               autocomplete="current-password"
               class="form-control"
               formControlName="oldPassword"
               [class.is-invalid]="passwordForm.get('oldPassword').invalid && passwordForm.get('oldPassword').touched"/>
        <control-messages [control]="passwordForm.get('oldPassword')"></control-messages>
      </div>
    </div>

    <div class="row form-group">
      <label for="settings-new-pw" class="col-sm-4 col-md-4 col-form-label">New password</label>
      <div class="col-md-6 col-lg-4">
        <input type="password"
               id="settings-new-pw"
               name="newPassword"
               autocomplete="new-password"
               class="form-control"
               formControlName="newPassword"
               [class.is-invalid]="passwordForm.get('newPassword').invalid && passwordForm.get('newPassword').touched"/>
        <control-messages [control]="passwordForm.get('newPassword')"></control-messages>
      </div>
    </div>

    <div class="row form-group">
      <label for="settings-conf-pw" class="col-sm-4 col-md-4 col-form-label">Confirm new password</label>
      <div class="col-md-6 col-lg-4">
        <input type="password"
               name="confirmPassword"
               autocomplete="new-password"
               id="settings-conf-pw"
               ui-validate-equals="vm.password.new"
               formControlName="confirmPassword"
               class="form-control"
               [class.is-invalid]="passwordForm.get('confirmPassword').invalid && passwordForm.get('confirmPassword').touched">
        <span class="text-error" *ngIf="passwordForm.errors?.passwordNotMatch">Passwords should match</span>
        <control-messages [control]="passwordForm.get('confirmPassword')"></control-messages>
      </div>
    </div>

    <div class="row form-group">
      <label for="settings-conf-pw" class="col-sm-4 col-md-4 col-form-label"></label>
      <div class="col-md-6 col-lg-4 ml-0">
        <button
          class="btn btn-info w-100"
          type="submit"
          angularticsCategory="settings"
          angulartics2On="click"
          angularticsAction="Save New Password"
          [disabled]="passwordForm.pristine || !passwordForm.valid"
        >
          Save
        </button>
      </div>
    </div>
  </form>
</span>
